
import Vue from 'vue'
import {Component} from 'vue-property-decorator'
import {Action, Getter, namespace} from 'vuex-class'
import BaseSubNavContainer from '@/containers/base/BaseSubNavContainer.vue'
import BaseListItemContainer from '@/containers/base/BaseListItemContainer.vue'
import {optionsVslim} from '@/config/v-slim-dialog'
import {demoUrl} from '@/config/service'

const prospectModule = namespace('prospect')
const essaiModule = namespace('essai')

@Component({
  components: {
    BaseSubNavContainer,
    BaseListItemContainer
  }
})
export default class ProspectEssai extends Vue {
  @prospectModule.Getter('prospectGetter') prospect: any
  @prospectModule.Action('getProspectByIdAction') getProspectById: any
  @essaiModule.Action('deleteEssaiAction') deleteEssai: any
  @essaiModule.Action('updateEssaiStatutAction') updateEssaiStatut: any

  get canCreateEssai() {
    const essais = this.prospect ? this.prospect.ESSAIS : null
    if (!essais || essais.length === 0) return true
    if (essais.length === 1 && (essais[0].CODE_REF_STATUT_ESSAI === 'E' || essais[0].CODE_REF_STATUT_ESSAI === 'S')) {
      return true
    } else {
      return false
    }
  }

  getLinkDemo(item) {
    return `${demoUrl}?CLE_ACCES=${item.CLE_ACCES_UTILISATEUR}`
  }

  async updateStatutHandler(id, statut) {
    let message = ''
    if (statut === 'S') message = "Confirmez vous l'archivage de l'essai ?"
    if (statut === 'A') message = "Confirmez vous l'activation de l'essai ?"
    const {ok} = await this.$dialogs.confirm(message, optionsVslim)
    if (ok) {
      this.updateEssaiStatut({
        id,
        statut
      }).then(async (data) => {
        await this.getProspectById(this.$route.params.id)
      })
    }
  }

  async onDelete(id: number) {
    const {ok} = await this.$dialogs.confirm("Confirmez vous la suppression de l'essai ?", optionsVslim)
    if (ok) {
      this.deleteEssai(id).then(async () => {
        await this.getProspectById(this.$route.params.id)
      })
    }
  }
}
